<template>
  <div style="overflow-y: hidden !important; height: 100vh !important">
    <div :key="index" v-for="(reactive, index) in reactives">
      <div v-if="reactive.timer > 0">
        {{ reactive }}
        <div
          v-if="reactive.status == 1"
          :id="'cover' + reactive.id"
          @click="
            startQuestion(
              answersStringToObject(reactive.answersList)[0].aspect,
              reactive.timer,
              index
            )
          "
          class="valign-wrapper card-panel indigo lighten-1"
          style="min-height: 80vh"
        >
          <div class="white-text center" style="margin: 0 auto">
            <i class="material-icons" style="font-size: 6rem">timer</i>
            <br />
            <h2 class="large-text">Cronómetro</h2>
            <p>Haz click aquí para mostrar la pregunta</p>
            <p>
              Tendrás
              <strong>{{ reactive.timer }}</strong> segundos para contestar
            </p>
          </div>
        </div>
        <div
          v-else-if="reactive.status == 2"
          :id="'question' + reactive.id"
          class="card-panel"
          style="min-height: 80vh"
        >
          <div class="medium-text">{{ reactive.title }}</div>
          <div style="margin: 5% 0">
            <i class="material-icons left">timer</i>
            La pregunta finalizará en
            <strong
              :id="'timer' + reactive.id"
              class="indigo white-text"
              style="border-radius: 1rem; padding: 2px"
              >{{ reactive.timer }}</strong
            >
            segundos
          </div>
          <form
            @submit.prevent="answered(reactive.id, answer.aspect, answer.value)"
            :key="index"
            v-for="(answer, index) in answersStringToObject(
              reactive.answersList
            )"
          >
            <button
              class="btn indigo waves-effect waves-light"
              style="
                text-align: left !important;
                width: 100%;
                margin-bottom: 5px;
              "
            >
              {{ answer.value }} {{ answer.text }}
            </button>
          </form>
        </div>
      </div>
      <div
        v-else
        :id="'question' + reactive.id"
        class="card-panel"
        style="min-height: 80vh"
      >
        <div v-if="reactive.status == 1" :id="'cover' + reactive.id">
          <div class="medium-text">{{ reactive.title }}</div>
          <br />
          <form
            @submit.prevent="answered(reactive.id, answer.aspect, answer.value)"
            :key="index"
            v-for="(answer, index) in answersStringToObject(
              reactive.answersList
            )"
          >
            <button
              class="btn indigo waves-effect waves-light"
              style="
                text-align: left !important;
                width: 100%;
                margin-bottom: 5px;
              "
            >
              {{ answer.value }} {{ answer.text }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";

export default {
  props: ["reactives"],
  data() {
    return {
      // reactivos y respuestas
      reactivesAnswers: [],

      aspectsList: {},
      aspectsTotalList: {},
      isCounted: true,
    };
  },
  methods: {
    answersStringToObject(string) {
      let answersPre = string.replace(/(\r\n\t|\n|\r\t)/g, "").split(";");
      let answers = [];

      answersPre.forEach((answer) => {
        answer = answer.split("//");
        let text = answer[0];
        let aspect = answer[1];
        let value = parseInt(answer[2]);

        if (answer[1]) {
          answers.push({
            text,
            aspect,
            value,
          });
        }
      });
      return answers;
    },
    answered(index, aspect, value) {
      this.reactivesAnswers.push({
        // guardar las respuestas de cada pregunta
        aspect,
        value,
      });

      this.reactives.shift(); // eliminar de la vista la pregunta respondida

      if (isNaN(this.aspectsList[aspect])) {
        this.aspectsList[aspect] = value;
      } else {
        this.aspectsList[aspect] = this.aspectsList[aspect] + value;
      }

      console.log(this.aspectsList);

      if (this.reactives.length > 0) {
        this.reactives[0].status = 1;
      }
    },
    calculateAspects() {
      let aspectsCalculated = {};
      Object.keys(this.aspectsTotalList).forEach((key) => {
        aspectsCalculated[key] =
          this.aspectsList[key] / this.aspectsTotalList[key];
        console.log(key);
      });
      console.log(aspectsCalculated);
      this.updateCalculatedAspects(aspectsCalculated);
      this.updateReactivesAnswers(this.reactivesAnswers);
      this.$emit("nextStep");
    },
    addAspectsTotalList() {
      if (this.isCounted) {
        this.reactives.forEach((reactive) => {
          let aspect = this.answersStringToObject(reactive.answersList)[0]
            .aspect;

          console.log(aspect);

          if (isNaN(this.aspectsTotalList[aspect])) {
            this.aspectsTotalList[aspect] = 1;
          } else {
            this.aspectsTotalList[aspect]++;
          }
        });
        console.log(this.aspectsTotalList);
        this.isCounted = false;
      }
    },
    ...mapMutations(["updateCalculatedAspects", "updateReactivesAnswers"]),
  },
  watch: {
    reactives(val) {
      this.stopSetInterval = true;
      if (this.reactives.length == 0) {
        this.calculateAspects();
      }
    },
  },
  updated() {
    this.addAspectsTotalList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/questionnaire/questionnaireSteps/questionnaire.vue